export type Processor = (node: any) => void;

export function traverseComponentTree(tree: any, processor: Processor): any {
  if (!tree.components) {
    return;
  }

  const compoTree = JSON.parse(JSON.stringify(tree));

  visitChildren(compoTree, processor);
  return compoTree;
}

function visitChildren(compoTree: any, processor: Processor): void {
  processor(compoTree);
  compoTree.components?.map((child: any) => {
    visitChildren(child, processor);
  });
}
